export default {
  'pages.myApps.title': '我的应用',
  'pages.myApps.description': '查看当前企业已开通的业务应用，开始团队工作。',
  'pages.myApps.backToCenter': '返回应用',
  'pages.myApps.refresh': '刷新',
  'pages.myApps.browseMarket': '浏览应用市场',
  'pages.myApps.overview': '应用概览',
  'pages.myApps.enabledCount': '已开通应用',
  'pages.myApps.availableCount': '可打开应用',
  'pages.myApps.unconfiguredCount': '未配置访问地址',
  'pages.myApps.currentPackage': '当前套餐',
  'pages.myApps.packageError': '套餐信息暂时无法加载。',
  'pages.myApps.retry': '重新加载',
  'pages.myApps.subscription.active': '生效中',
  'pages.myApps.subscription.expired': '已到期',
  'pages.myApps.subscription.suspended': '已暂停',
  'pages.myApps.subscription.cancelled': '已取消',
  'pages.myApps.subscription.unknown': '状态待确认',
  'pages.myApps.startsAt': '生效日期',
  'pages.myApps.expiresAt': '到期日期',
  'pages.myApps.noExpiry': '长期有效',
  'pages.myApps.dateUnknown': '暂无日期',
  'pages.myApps.noPackage': '暂无当前套餐，已开通的应用可继续使用。',
  'pages.myApps.appList': '已开通应用',
  'pages.myApps.accessDescription':
    '应用将在新窗口打开；未配置访问地址的应用暂不可打开。',
  'pages.myApps.searchLabel': '搜索应用',
  'pages.myApps.searchPlaceholder': '搜索应用名称或 ID',
  'pages.myApps.filterLabel': '按开通来源筛选',
  'pages.myApps.source.all': '全部应用',
  'pages.myApps.source.package': '套餐开通',
  'pages.myApps.source.tenant': '单独开通',
  'pages.myApps.source.other': '其他来源',
  'pages.myApps.resultCount': '找到 {count} 个应用',
  'pages.myApps.loadError': '应用列表暂时无法加载',
  'pages.myApps.loadErrorDescription': '请重新加载。当前开通记录不会受到影响。',
  'pages.myApps.emptyTitle': '尚未开通应用',
  'pages.myApps.emptyDescription':
    '浏览应用市场，发现适合企业与团队的业务工具。',
  'pages.myApps.noResults': '没有匹配的应用',
  'pages.myApps.noResultsDescription':
    '尝试其他应用名称或 ID，或清除搜索与来源筛选。',
  'pages.myApps.clearFilters': '清除筛选',
  'pages.myApps.available': '可打开',
  'pages.myApps.unconfigured': '未配置访问地址',
  'pages.myApps.openApp': '打开应用',
  'pages.myApps.openAppAccessible': '打开 {name}（新窗口）',
  'pages.myApps.newWindow': '新窗口',
  'pages.myApps.accessUnavailable': '暂不可打开',
  'pages.myApps.paginationTotal': '共 {total} 个应用',
};
